import React, { useEffect } from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PaginateProductsState } from 'store/ducks/settings/products';

import * as S from './styles';
import { useTranslation, usePermissions } from 'hooks';
import { translations } from './translations';

import { MainContainer, Paginator, MenuSelector } from 'components/shared';
import { GridProducts, FilterProducts } from 'components/settings';
import { useFilters } from 'hooks/useFilters';

export const ListProducts: React.FC = () => {
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();

  const { getData } = useFilters('products');

  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateProducts
  ) as PaginateProductsState;

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation('configuracoes')} <MenuSelector page="products" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission('insertProduct') && (
            <S.ButtonMini
              onClick={() => history.push('/settings/products/new')}
            >
              {getTranslation('novoProduto')}
            </S.ButtonMini>
          )}
          <FilterProducts />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridProducts products={data} />
        <Paginator
          pagination={pagination}
          settingsPage="products"
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
